<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="My Homeworks">
      <v-card-text class="pt-0 pr-1"
        :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
        <!--Filter Section Start -->
        <v-row>
          <!-- <v-col cols="12" md="4">
            <label class="label">From </label>
            <div class="control">
              <input class="input" max="9999-12-31" type="date" v-model="filter.fromDate"
                v-on:change="onFilterChange" required />
            </div>

          </v-col>
          <v-col cols="12" md="4">

            <label class="label">To </label>
            <div class="control">
              <input class="input" max="9999-12-31" type="date" v-model="filter.toDate"
                v-on:change="onFilterChange" required />
            </div>
          </v-col> -->
          <v-col cols="12" md="6" lg="3" class="pt-2 mt-3">
            <label class="font-weight-medium body-2">From </label>
            <custom-date-picker label="From" dense prepend-icon="mdi-calendar"
              :maxToDate="maxToDate" v-model="filter.fromDate" required />
          </v-col>
          <v-col cols="12" md="6" lg="3" class="pt-2 mt-3">
            <label class="font-weight-medium body-2">To </label>
            <custom-date-picker label="To" dense prepend-icon="mdi-calendar"
              :minToDate="filter.fromDate" v-model="filter.toDate" required />
          </v-col>
          <v-col cols="12" md="6" lg="3">
            <span class="font-weight-medium body-2">Action</span>
            <div class="inside">
              <v-btn elevation="1" color="success" @click="onFilterChange">
                <v-icon left>mdi-magnify</v-icon>Search
              </v-btn>
            </div>
          </v-col>
          <v-col cols="12" md="6" lg="3">
            <label class="font-weight-medium body-2">
              Status
            </label>
            <v-autocomplete class="my-0 py-1" placeholder="--All--" name="statusSelect"
              v-model="statusSelect" required v-on:change="getStudentHomework()" item-value="id"
              :items="statusOptions" key="opt" item-text="name">
            </v-autocomplete>
          </v-col>
        </v-row>
        <!--Filter section end -->
      </v-card-text>
      <v-data-table :footer-props="{
          'items-per-page-options': [5, 10, 20, 40]
        }" :items-per-page="10" item-key="uniqueKey" :headers="headers" :items="homeworks">
        <!--Status Start -->
        <template v-slot:item.date="item">
          {{ formatDate(item.item.date) }}
        </template>
        <!--Status End -->
        <template v-slot:item.id="item">
          <router-link :to="{ name: `homeworkUpload`, params: { id: item.item.id } }">
            <!-- {{test(item.item)}} -->
            <v-btn color="success" class="px-2 ml-1 ma-1" min-width="0" small>
              <b-icon class="file-icon" icon="upload"></b-icon> <span
                class="ml-1">{{ item.item.homeworkStatus === 'NOT UPLOADED' ? 'Upload Homework' : 'Edit Homework'  }}
              </span>
            </v-btn>
          </router-link>
        </template>

        <!--No Data template start -->
        <template v-slot:no-data>
          <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
        </template>
        <!--No Data template end -->
      </v-data-table>
    </material-card>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import moment from 'moment'
import stores from '@/stores'

export default {
  name: 'uploadHomework',
  components: { MaterialCard, CustomDatePicker },
  data: function () {
    return {
      homeworks: [],
      isLoading: true,
      statusSelect: '',
      studentId: '',
      headers: [
        { text: 'Teacher Name', sortable: true, value: 'users[0].firstName' },
        { text: 'Assigned on', sortable: false, value: 'date' },
        { text: 'Status', sortable: true, value: 'homeworkStatus' },
        { text: 'Action', sortable: true, value: 'id' }
      ],
      statusOptions: [
        {
          opt: '',
          name: 'All'
        },
        {
          opt: 'Complete',
          name: 'Complete'
        },
        {
          opt: 'Incomplete',
          name: 'Incomplete'
        }
      ],
      selectedClassID: '',
      timer: null,
      maxToDate: moment().format('YYYY-MM-DD'),
      filter: {
        fromDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD')
      }
    }
  },
  created: async function () {
    this.studentId = stores.user.me.userStudentMap?.studentAdmission.id
    console.log(this.studentId, 'this.studentID')
    this.getStudentHomework()
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      console.log(val)
    }
  },
  methods: {
    onFilterChange: function () {
      let that = this
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        that.getStudentHomework()
      }, 1000)
    },
    getStudentHomework: async function () {
      try {
        this.isLoading = true
        let requestParams = {}
        requestParams.studentID = this.studentID
        requestParams.isActive = true
        requestParams.franchiseeID = stores.user.franchisee.id
        requestParams.academicYearID = stores.user.me.userStudentMap?.studentAdmission?.academicYearID
        requestParams.classID = stores.user.me.userStudentMap?.studentAdmission?.classID
        requestParams.sectionID = stores.user.me.userStudentMap?.studentAdmission?.sectionID
        requestParams.fromdate = this.filter.fromDate
        requestParams.todate = this.filter.toDate

        if (this.franchisee.id !== '' && requestParams.academicYearID !== undefined && requestParams.classID !== undefined && requestParams.sectionID !== undefined) {
          const { data } = await http.get(`${constants.API_URL}/api/communication/getstudenthomework`, {
            params: requestParams
          })
          this.homeworks = this.filterData(this.processData(data))
          console.log(this.homeworks)
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$buefy.toast.open({
          message: errorMessage,
          type: 'is-danger',
          duration: 4000
        })
      }
    },
    formatDate (date) {
      console.log(date)
      return moment(date).format('LL')
    },
    processData (data) {
      return data.map((item) => {
        if (item.teacherId) {
          item.users[0].firstName = `${item.users[0].firstName} ${item.users[0].lastName}`
        } else {
          item.users.push({
            firstName: 'Not Available'
          })
        }
        let flag = false
        item.studentHomeWorks.forEach((ele) => {
          if (ele.studentID === this.studentId) {
            flag = true
            item.homeworkStatus = ele.approvalStatus === 'Not Reviewed' ? 'INCOMPLETE' : 'COMPLETE'
          }
        })
        if (!flag) {
          item.homeworkStatus = 'NOT UPLOADED'
        }
        return item
      })
    },
    filterData (arr) {
      return arr.filter((item) => {
        if (this.statusSelect === 'Complete') {
          return item.homeworkStatus === 'COMPLETE'
        } else if (this.statusSelect === 'Incomplete') {
          return item.homeworkStatus === 'INCOMPLETE'
        }
        return true
      })
    }
  }
}
</script>
<style scoped>
h3 {
  text-align: center;
}
</style>
